/* Shto motion: tells the CSS when a moving part of our sections is on screen. Nothing else; all motion is CSS.
   data-shto-motion="once"  gets .shto-in the first time it is on screen (plays once).
   data-shto-motion="loop"  gets .shto-in while on screen, and .shto-off (paused) once it has left.
   With reduced motion, or without IntersectionObserver, nothing is added and everything stays exactly as in Figma.
   Loaded with defer by every section that moves; runs once. */
(function () {
  if (window.ShtoMotion) return;
  window.ShtoMotion = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var el = e.target;
      if (reduce && reduce.matches) return;
      if (e.isIntersecting) {
        el.classList.add('shto-in');
        el.classList.remove('shto-off');
        if (el.getAttribute('data-shto-motion') === 'once') io.unobserve(el);
      } else if (el.classList.contains('shto-in')) {
        el.classList.add('shto-off');
      }
    });
  }, { threshold: 0.35 });

  function watch(root) {
    (root || document).querySelectorAll('.shto [data-shto-motion]').forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); });
  else watch();
  // Theme editor: a section that is edited is drawn again.
  document.addEventListener('shopify:section:load', function (e) { watch(e.target); });
})();
